import React, { useState } from 'react';
import ImageDecoder from '../../Utils/ImageDecoder/ImageDecoder';
import { hasPicture } from '../../Utils/pictures';
import './PicturesGallery.scss';
import Col from 'react-bootstrap/Col';
import { useLanguage } from '../../../LanguageContext';
import DeepZoomViewer from '../../DeepZoom/DeepZoomViewer';

const PicturesGallery = ({ currentArtwork, isArrayEmpty }) => {

  const { selectedLanguage } = useLanguage();
  const getLangValue = (data) => {
    return data ? data[selectedLanguage === 'it' ? 'it_IT' : 'en_GB'] : '';
  };

  // immagine attualmente aperta nel viewer deep zoom IIIF (null = chiuso)
  const [zoomPicture, setZoomPicture] = useState(null);

  // solo le picture con un file: la URL IIIF di una picture vuota darebbe 404
  const pictures = (currentArtwork.pictures || []).filter(hasPicture);

  return (
    !isArrayEmpty(pictures) && (
      <Col className="col-12 col-md-12">
        <label>
          <strong>{selectedLanguage === 'it' ? 'Galleria immagini' : 'Pictures gallery'}</strong>
        </label>
        <div className="boxGall">
          {pictures.map((image, index) => {
            const title = getLangValue(image.title);
            return (
              <figure className="gallCard" key={image.id || index}>
                {title && (
                  <figcaption className="gallTitle" title={title}>
                    {title}
                  </figcaption>
                )}
                <div className="gallImgBox">
                  <ImageDecoder
                    className="gallImg"
                    pictureId={image.id}
                    altText={title}
                    isGallery={true}
                  />
                </div>
                <div className="gallActions">
                  <button
                    type="button"
                    className="btn btn-sm btn-outline-dark"
                    onClick={() => setZoomPicture(image)}
                  >
                    🔍 {selectedLanguage === 'it' ? 'Esplora in alta risoluzione' : 'Explore in high resolution'}
                  </button>
                </div>
                {image.credit && (
                  <div className="gallCredit" title={image.credit}>
                    {image.credit}
                  </div>
                )}
                <div className="gallCreditLink">
                  <a href="/credits" className="AimgGall">© Credits</a>
                </div>
              </figure>
            );
          })}
        </div>
        {zoomPicture && (
          <DeepZoomViewer
            pictureId={zoomPicture.id}
            title={getLangValue(zoomPicture.title)}
            onClose={() => setZoomPicture(null)}
          />
        )}
      </Col>
    )
  );
};

export default PicturesGallery;
